module.exports = __webpack_public_path__ + "static/media/84 - Mac Demarco - Chamber Of Reflection.b77a5504.mp3";